<template>
    <div class="container header">
        <div class="title">
            <router-link :to="{name: 'home'}">
                <h2>Aaron Gabriel Fulgar</h2>
            </router-link>
        </div>
        <div class="links">
            <router-link :to="{name: 'home'}">Home</router-link>
            <router-link :to="{name: 'about'}">About</router-link>
            <router-link :to="{name: 'projects'}">Projects</router-link>
            <router-link :to="{name: 'experiences'}">Experience</router-link>
            <router-link :to="{name: 'contact'}">Contact</router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Header'
    }
</script>